<template>
  <div class="container-fluid">
    <h3 v-if="loadedTable">
      Carregando...
    </h3>
    
    <template v-else-if="table">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="table-name">Nome</label>
            <input v-model="table.name" id="table-name" class="form-control" disabled="disabled">
          </div>
        </div>
        
        <div class="col-md-1">
          <div class="form-group">
            <label for="table-public" class="mr-2">Público</label>
            <input v-model="table.public" id="table-public" type="checkbox" disabled="disabled">
          </div>
        </div>
        
        <div class="col-md-2">
          <div class="form-group">
            <label for="table-public" class="mr-2">uuid</label>
            <input v-model="table.uuid" id="table-public" disabled="disabled" class="form-control">
          </div>
        </div>
        
        <div class="col-md-6">
          <div class="form-group">
            <label for="table-description" class="mr-2">Descrição</label>
            <textarea
              v-model="table.description"
              id="table-description"
              class="form-control"
              disabled="disabled"
              rows="1"
            />
          </div>
        </div>
      </div>
    
      <hr>
      <div class="row">
        <div class="col-md-12">
          <Rows :table="table" :isTableOwner="isTableOwner"/>
        </div>
      </div>
    </template>
    
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import GetAccount from '../../../mixins/GetAccount.vue'
import Rows from '@/components/custom_table/table/Rows'
import { mapMutations } from 'vuex'

export default {
  activated() {
    this.loadTable()
  },
  components: { Rows },
  computed: {
    isTableOwner() {
      return this.getAccount.id === this.table.accountId
    }
  },
  data: () => ({
    loadedTable: true,
    modelPathPrefix: 'custom_table',
    nameModel: 'Table',
    table: null,
  }),
  deactivated() {
    this.table = null
    this.setNameBreadcrumb('...')
  },
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
    loadTable() {
      this.asyncTemplateShow(this.id, {
        after: ({model}) => this.table = model,
        finish: () => {
          this.loadedTable = false
          this.setNameBreadcrumb(this.table.name)
        }
      })
    }
  },
  mixins: [GetAccount, ModelMapper],
  name: 'Show',
  props: ['id']
}
</script>

<style scoped>

</style>